import { RouteComponentProps } from "react-router-dom";

import { eventPath } from "../components/live-event/utils";
import { BrandliveEvent, LanguagesAbbr, RegistrationStepType, Session, SessionPreview } from "../types/working-model";
import { hasEventAccess, hasSessionAccess } from "./registration-utils";

interface IProps {
	event: BrandliveEvent | null;
	workingEvent: BrandliveEvent | null;
	session: Session | SessionPreview;
	language: LanguagesAbbr;
	selectedLanguage?: LanguagesAbbr;
	eventName?: string;
	validSessions: string[];
	finishedRegistering: boolean;
	userVerified: boolean;
	firesidesHostSessions: number[];
	paidSessions?: string[];
	paramsUuid?: string;
	history: RouteComponentProps['history'];
}

const handleSessionCardClick = (props: IProps) => {
	const {
		event,
		workingEvent,
		session,
		language,
		eventName,
		validSessions,
		finishedRegistering,
		firesidesHostSessions,
		userVerified,
		paidSessions,
		paramsUuid,
		history,
		selectedLanguage,
	} = props;

	const userHasAccess = !!workingEvent || hasEventAccess(event, validSessions, finishedRegistering, userVerified, firesidesHostSessions);

	const ticketingStep = event?.registration_steps?.find(step => step.type == RegistrationStepType.ticketing && step.isOn);

	const sessionAccess = hasSessionAccess(event, session, validSessions, paidSessions, undefined, ticketingStep);

	const sessionLink = () => {

		let sessionHasTicket = false;

		if (ticketingStep) {
			const sessionTickets = ticketingStep.ticketing?.filter(ticket => ticket.session_uuids.indexOf(session.uuid) >= 0) || [];

			if (sessionTickets?.length > 0) {
				sessionHasTicket = true;
			}
		}

		if (!sessionAccess) {
			let baseUrl = `/${eventPath(eventName, paramsUuid)}/${language}/registration`;

			if (sessionHasTicket) {
				baseUrl = `${baseUrl}/${session.uuid}`;
			}

			return baseUrl;
		} else {
			return `/${eventPath(eventName, paramsUuid)}/${selectedLanguage || language}/session/${session.uuid}`;
		}
	};

	if (!userHasAccess) {
		history.push(`/${eventPath(eventName, paramsUuid)}/${selectedLanguage || language}/registration`);
	} else if (!sessionAccess) {
		return;
	} else {
		if (session.custom_url_enabled && session.custom_url) {
			window.open(session.custom_url, '_blank');
		} else {
			history.push({ pathname: sessionLink(), state: { from: history.location.pathname } });
		}
	}
};

export default handleSessionCardClick;
